import { render, staticRenderFns } from "./CardPhotoExample.vue?vue&type=template&id=1fb1e63e&scoped=true&lang=true&"
import script from "./CardPhotoExample.vue?vue&type=script&lang=js&"
export * from "./CardPhotoExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1e63e",
  null
  
)

export default component.exports